import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export async function salvarColunasCarteira(colunasCarteira: string[]) {
  const url = `${leadsWebEnviroment}/commom/leads/colunas-carteira/v1`;
  const response = await instance.put(url, { colunasCarteira });
  return response?.data;
}
